import styled from 'styled-components'
import { Row, Col } from 'antd'

import { PrimaryBtn, Btn } from 'components/button'

import BaseDialog from './BaseDialog'

const ConfirmDialog = (props) => {
  const { visible, title, message, onClose, onConfirm } = props

  return (
    <BaseDialog visible={visible} onClose={onClose}>
      <Content>
        <Title>{title}</Title>
        <Message>{message}</Message>
        <Footer>
          <Row>
            <Col lg={9} xs={24}>
              <Cancel>
                <Btn text="ยกเลิก" onClick={onClose} />
              </Cancel>
            </Col>
            <Col lg={15} xs={24}>
              <Confirm>
                <PrimaryBtn text="ตกลง" onClick={onConfirm} />
              </Confirm>
            </Col>
          </Row>
        </Footer>
      </Content>
    </BaseDialog>
  )
}

const Content = styled.div`
  width: 100%;
  min-width: 320px;
`

const Title = styled.div`
  font-size: 18px;
  margin-bottom: 20px;
  color: ${(props) => props.theme.color.black};
`

const Message = styled.div`
  font-size: 14px;
  margin-bottom: 20px;
  color: ${(props) => props.theme.color_level.grey.high};
`

const Cancel = styled.div`
  padding-right: 8px;
`

const Confirm = styled.div`
  padding-left: 8px;
`

const Footer = styled.div`
  width: 100%;
`

export default ConfirmDialog
